"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noErrorToDisplay = exports.displayError = exports.initializationError = exports.sendingBookingDataError = exports.sendingBookingData = exports.booking = exports.sendingReferralDataError = exports.sendingReferralData = exports.maxReferrals = exports.someReferrals = exports.noReferrals = exports.referral = exports.initialized = exports.ready = exports.invalidPatientData = exports.init = exports.completeInitializing = exports.noPatientDataReceived = exports.requestPatientFailed = exports.requestPatientAwaitingResponse = exports.sendingPatientRequest = exports.invalidPostMessageUrl = exports.validatingPostMessageUrl = exports.initializing = void 0;
exports.initializing = 'INITIALIZING';
exports.validatingPostMessageUrl = 'VALIDATING_POST_MESSAGE_URL';
exports.invalidPostMessageUrl = 'INVALID_POST_MESSAGE_URL';
exports.sendingPatientRequest = 'SENDING_PATIENT_REQUEST';
exports.requestPatientAwaitingResponse = 'REQUEST_PATIENT_AWAITING_RESPONSE';
exports.requestPatientFailed = 'REQUEST_PATIENT_FAILED';
exports.noPatientDataReceived = 'NO_PATIENT_DATA_RECEIVED';
exports.completeInitializing = 'COMPLETE_INITIALIZING';
exports.init = 'INIT';
exports.invalidPatientData = 'INVALID_PATIENT_DATA';
exports.ready = 'READY';
exports.initialized = 'INITIALIZED';
exports.referral = 'REFERRAL';
exports.noReferrals = 'NO_REFERRALS';
exports.someReferrals = 'SOME_REFERRALS';
exports.maxReferrals = 'MAX_REFERRALS';
exports.sendingReferralData = 'SENDING_REFERRAL_DATA';
exports.sendingReferralDataError = 'SENDING_REFERRAL_DATA_ERROR';
exports.booking = 'BOOKING';
exports.sendingBookingData = 'SENDING_BOOKING_DATA';
exports.sendingBookingDataError = 'SENDING_BOOKING_DATA_ERROR';
exports.initializationError = 'INITIALIZATION_ERROR';
exports.displayError = 'DISPLAY_ERROR';
exports.noErrorToDisplay = 'NO_ERROR_TO_DISPLAY';
//# sourceMappingURL=states.js.map